export default "__VITE_ASSET__TDpaAX4J__"